import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {NumberUtil} from '@aperza/util';
import {CloseButton} from '@aperza/ui';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Theme from '../../ui/Theme';
import {Button, Message, Loading} from '@aperza/ui';
import Alert from 'react-bootstrap/Alert';
import CatalogInquiryForm from './CatalogInquiryForm';
import CustomerInfoForm from './CustomerInfoForm';
import {createRefetchContainer, graphql} from "react-relay";
import FormFieldUtil from "../../util/FormFieldUtil";
import DownloadCatalogMutation from '../../mutation/DownloadCatalogMutation';
import CatalogDownloadSuccessPanel from './CatalogDownloadSuccessPanel';

import TdWebService from '../../service/TdWebService';
import AppService from '../../service/AppService';
import AppConfig from '../../domain/AppConfig';

import style from './CatalogDownloadModal.module.scss';
import Survey from "../survey/Survey";

const appConfig: AppConfig = AppService.appConfig();

const CatalogDownloadModal = (props) => {

  let {
    viewer,
    requestId,
    catalogId,
    companyId,
    companyContractDisplayId,
    catalogPreview,
    documentId,
    show,
    errorId,
    onClose,
  } = props;

  // let [show, setShow] = useState(false);
  let [step, setStep] = useState(1);
  let [readOnly, setReadOnly] = useState(false);
  const catalogInquiryFormRef = useRef();

  useEffect(() => {
    if (documentId && catalogId && (companyId||companyContractDisplayId)) {
      setStep(1);
    }
  }, [requestId]);

  const onModalClose = () => {
    //setShow(false);
    if (onClose) {
      onClose();
    }
  };

  const afterSubmitSurvey = (data) => {
    if (data && data.response && data.response.downloadUrl) {
      let downloadUrl = data.response.downloadUrl;
      let url = new URL(downloadUrl);
      let filename;
      if (url && url.pathname) {
        let parts = url.pathname.split('/');
        if (parts && parts.length) {
          filename = parts[parts.length-1];
        }
      }
      let element = document.getElementById('catalogDownloadLink');
      if (!element) {
        element = document.createElement('a');
        element.target = '_blank';
        element.style = 'display:none;'
        document.body.appendChild(element);
      }
      element.download = filename;
      element.href = downloadUrl;
      element.click();
    };
    setStep(2);
  };

  return (

      <Modal
        show={show}
        onHide={onModalClose}
        size={'lg'}
        id="catalogWebDownloadModal"
        dialogClassName={style.CatalogDownloadModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Message messageId="catalogDownload"/>
            {viewer && viewer.isInternalUser &&
            <p style={{color: '#FF0000'}}>運営者でログインしています。引き合いの登録は行われません。</p>
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={style.CatalogDownloadModalBody}>
          {step !== 2 &&
          // <Alert variant={'secondary'}>
          //   <Message messageId="enquete_message6"/>
          // </Alert>
          <Container fluid="true" className="aw-form">
            { catalogPreview &&
            <p className="modal-return-link">
              <a href="#" onClick={onModalClose} ><i className="fa fa-fw fa-angle-left"></i><Message messageId="catalogDownloadReturn" /></a>
            </p>
            }
            <p>
              <span className="font-weight-bold">アンケートとお客様情報を入力後、「入力内容を確認する」へお進みください。</span>
            </p>
            <p>
              <span className="text-danger required">*</span>の項目は入力必須です。
            </p>
          </Container>
          }
          {errorId &&
          <Container fluid="true" className="aw-form">
            <div className={'d-flex justify-content-center align-items-center flex-column'}>
              <div>Oops! Something went wrong! Please try again!</div>
              <CloseButton onClick={onModalClose} />
            </div>
          </Container>
          }
          {!viewer && !errorId &&
          <Container fluid="true" className="aw-form">
          <Loading/>
          </Container>
          }
          {step !== 2 && viewer &&
          <Survey leadType={'DOWNLOAD_CATALOG'}
                  relatedIds={[documentId]}
                  showUserInfo={true}
                  viewer={viewer}
                  afterSubmitSurvey={afterSubmitSurvey}
          />
          }
          {step == 2 && viewer &&
          <CatalogDownloadSuccessPanel documentId={documentId} />
          }
        </Modal.Body>
      </Modal>

  )

};

CatalogDownloadModal.fragments = {
  viewer: gql`
      fragment CatalogDownloadModal_viewer on Viewer {
          id
          userId
          isLogin
          isInternalUser
          cluezUser {
              id
              locale
              addressLargeAreaId
              statusCode
              countryCode
          }
          ...Survey_viewer
      }
    ${Survey.fragments.viewer}
  `
};

CatalogDownloadModal.propTypes = {
  viewer: PropTypes.any, //null is the QueryRenderer is still loading
  onClose: PropTypes.func,
  companyContractDisplayId: PropTypes.number,
  catalogId: PropTypes.number,
  companyId: PropTypes.number,
  requestId: PropTypes.string,
  documentId: PropTypes.string,
  catalogPreview: PropTypes.bool,
};

export default CatalogDownloadModal;
